"use strict";

module.exports = {

    onChange: function (output, action) {
        var dom = action.dom;

        if (dom) {
            for (var key in output) {
                dom.setAttribute(key, output[key]);
            }
        }
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes/attr.js
 ** module id = 11
 ** module chunks = 0
 **/